import { createSelector } from 'reselect';
import { get } from 'lodash';
import {
  isSurveyConfigManagedTargeting,
  isSurveyConfigMultiCountries,
} from '../Permissions/helpers';

const selectSurveyDomain = (state) => get(state, 'survey', {});

const makeSelectIsDistributionLink = createSelector(
  selectSurveyDomain,
  (substate) => get(substate, 'surveyDetails.isDistributionLink', false),
);

const makeSelectIsPeeq = createSelector(selectSurveyDomain, (substate) =>
  get(substate, 'surveyDetails.isPeeq', false),
);

const makeSelectIsThirdParty = createSelector(selectSurveyDomain, (substate) =>
  get(substate, 'surveyDetails.isThirdParty', false),
);

const makeSelectIsSurveyManagedTargeting = createSelector(
  selectSurveyDomain,
  (substate) =>
    isSurveyConfigManagedTargeting({
      surveyConfig: get(substate, 'surveyDetails.surveyConfig'),
    }),
);

const makeSelectIsRegular = createSelector(selectSurveyDomain, (substate) => {
  const surveyDetails = get(substate, 'surveyDetails', {});
  const { isPeeq, isDistributionLink, isInternal, isThirdParty } =
    surveyDetails;
  return !isPeeq && !isDistributionLink && !isInternal && !isThirdParty;
});

const makeSelectSupportsMultiCountries = createSelector(
  selectSurveyDomain,
  (surveyState) => isSurveyConfigMultiCountries(surveyState),
);

export {
  selectSurveyDomain,
  makeSelectIsDistributionLink,
  makeSelectIsPeeq,
  makeSelectIsRegular,
  makeSelectIsThirdParty,
  makeSelectIsSurveyManagedTargeting,
  makeSelectSupportsMultiCountries,
};
